
import { useDispatch, useSelector } from 'react-redux';

import { selectLoadingState, setLoading } from '../../services/global/globalSlice';
import { useEffect, useState } from 'react';
import { fetchBiToken } from './AnalyticsApi';
import { selectTranslations } from '../../services/i18n/i18nSlice';

import page_icon from '../../components/Navigation/icons/stats.svg'
import timer_img from '../../assets/images/timer.svg'
import { selectTenantSettings } from '../../services/utils/appInfoSlice';


export default function AnalyticsScreen ({children}) {

    const t = useSelector(selectTranslations)
    const tenantInfo = useSelector(selectTenantSettings)

    const [biUrl, setBiUrl] = useState(null)
    const dispatch = useDispatch()

    const loadPage = async () => {
        dispatch(setLoading(true))
        const response = await fetchBiToken()
        if(response.success){
            setBiUrl(response.data)
        } else {
            dispatch(setLoading(false))
        }
    }

    const handleLoadIframe = ( ) => {
        dispatch(setLoading(false))
    }

    useEffect(()=>{
        loadPage()
    },[])
  
    const isLoading = useSelector(selectLoadingState)
    return(
        <section id="analyticsScreen" className='h-100'>
            <div className="page_title">
                <img src={page_icon} alt=''/>
                <h1>{t.analytics.page_title}</h1>
            </div>
            {
                tenantInfo && !tenantInfo?.active_contract ?
                <div className="folder_alert mt-3">
                    <div className="d-flex align-items-start">
                        <img src={timer_img} />
                        <div className="ms-2">
                            <h3> {t.analytics.welcome_title}</h3>
                            <p className="mb-0">{t.analytics.demo_text}</p>
                        </div>
                    </div>
                </div> : <div className="folder_info mt-3">
                    <div className="d-flex align-items-center">
                        <img src={timer_img} />
                        <div className="ms-2">
                            <p className="mb-0">{t.analytics.update_text}</p>
                        </div>
                    </div>
                </div>
            }
            {
                biUrl ?
                    <>
                        <iframe src={biUrl} style={{width:'100%', height:'83%'}} onLoad={handleLoadIframe}/>
                    </>
                    
                :
                    <h1 className='text-center mt-5'>Al momento le statistiche non sono disponibili</h1>
            }
        </section>
    )
}